import React, { useState } from 'react'

const Navbar = () => {
    const [activeNav, setActiveNav] = useState(false)
  return (
    <header>
    <div className="bg-black cl-w fw-medi f-14 d-flex justify-content-center p-2">
        <marquee className="blink">
            <i>India's Biggest Exporter Of Dehydrated Food Products</i>
        </marquee>
    </div>
    {/* <!-- <marquee className="bg-black cl-w fw-medi f-14 d-flex justify-content-center p-2"><i>Announcment Bar ( Text Here )</i></marquee> --> */}

    <div className="bg-white mbludrLine">
        <div className="container">

            <div className="d-flex justify-content-center align-items-center py-3">
                <a href="/" className="me-auto wow animate__fadeIn" data-wow-duration="1s">
                    <img src="/images/IntegroExim Header Logo.png" alt="Logo of IntegroExim" draggable="false" className="img-fluid Logo" />
                </a>
                <div className="d-none d-lg-flex justify-content-center align-items-center">

                    <a href="tel:+919016410432" className="d-flex justify-content-center align-items-center headerLinePad wow animate__fadeInLeft" data-wow-delay="0s" data-wow-duration="1s">
                        <div><img src="/images/phone.png" alt="Icon of Call" draggable="false" className="img-fluid HeadContIcon" /></div>
                        <div className="d-flex flex-column justify-content-center align-items-start ps-3  VericalLine">
                            <div className="fw-bold f-22">+91 84600 24742</div>
                            <div className="fw-medi cl-8b f-18">Make A Call</div>
                        </div>
                    </a>

                    <a href="mailto: info@integroexim.com?subject=Hello IntegroExim Team" className="d-flex justify-content-center align-items-center wow animate__fadeInLeft" data-wow-delay="0.2s" data-wow-duration="1s">
                        <div><img src="/images/mail.png" alt="Icon of Mail" draggable="false" className="img-fluid HeadContIcon" /></div>
                        <div className="d-flex flex-column justify-content-center align-items-start ps-3">
                            <div className="fw-bold f-22">info@integroexim.com</div>
                            <div className="fw-medi cl-8b f-18">Get An Estimate</div>
                        </div>

                    </a>
                </div>


                <div className="navBoxicon ms-auto d-block d-lg-none navIcon" onClick={e => setActiveNav(!activeNav)}>
                    <img src="/images/menu_icon.png" alt="Menu icon" draggable="false" className="img-fluid menuIcon" />
                </div>

            </div>

        </div>
    </div>

    <nav className="bg-theme cl-w f-14 d-flex justify-content-center d-none d-lg-block">
        <div className="container">
            <ul className="cusUL d-flex justify-content-center align-items-center">
                <li>
                    <a href="/" className="cusA cusNav text-white f-14">Home</a>
                </li>
                <li className="megaHover">
                    <a href="#" className="cusA cusNav text-white f-14">Our Products</a>
                    <ul className="MegaMenu">
                        <li><a href="/spices">Spices</a></li>
                        <li><a href="/onion">Onion Products</a></li>
                        <li><a href="/garlic">Garlic Products</a></li>
                        <li><a href="/raisins">Raisins (Dried Grapes)</a></li>
                        <li><a href="/vegetable">Vegetable Powder</a></li>
                    </ul>
                </li>
                <li>
                    <a href="/about" className="cusA cusNav text-white f-14">About Us</a>
                </li>
                <li>
                    <a href="/certificates" className="cusA cusNav text-white f-14">Certification</a>
                </li>
                <li>
                    <a href="/contact" className="cusA cusNav text-white f-14">Contact Us</a>
                </li>
            </ul>
        </div>
    </nav>

    <nav className="d-block d-lg-none">
        <ul className={`navbar pt-3 ${activeNav && 'navbarActive'}`}>
            <li className="nav Close" onClick={e => setActiveNav(false)}><a href="#" className="nvitm"><img src="/images/close_icon.png" alt="Close icon" draggable="false" className="img-fluid CloseIcon" /></a></li>
            <hr className="w-100 CusHR" />
            <li className="nav"><a href="/" className="nvitm">Home</a></li>
            <li className="nav"><a href="/spices" className="nvitm">Spices</a></li>
            <li className="nav"><a href="/onion" className="nvitm">Onion Products</a></li>
            <li className="nav"><a href="/garlic" className="nvitm">Garlic Products</a></li>
            <li className="nav"><a href="/raisins" className="nvitm">Raisins (Dried Grapes)</a></li>
            <li className="nav"><a href="/vegetable" className="nvitm">Vegetable Powder</a></li>
            <li className="nav"><a href="/about" className="nvitm">About Us</a></li>
            <li className="nav"><a href="/certificates" className="nvitm">Certification</a></li>
            <li className="nav"><a href="/contact" className="nvitm">Contact Us</a></li>
            <hr className="w-100 CusHR" />
            <li className="nav d-flex justify-content-start px-4">
                <div className="d-flex flex-column justify-content-center align-items-start">
                    <a href="tel:+918460024742" className="d-flex justify-content-center align-items-center headerLinePad my-3">
                        <div><img src="/images/phone.png" alt="Icon of Call" draggable="false" className="img-fluid HeadContIcon" /></div>
                        <div className="d-flex flex-column justify-content-center align-items-start ps-3  VericalLine">
                            <div className="fw-bold HeadContIconHead">+91 84600 24742</div>
                            <div className="fw-medi cl-8b HeadContIconDes">Make A Call</div>
                        </div>
                    </a>
                    <a href="mailto: info@integroexim.com?subject=Hello IntegroExim Team" className="d-flex justify-content-center align-items-center my-3">
                        <div><img src="/images/mail.png" alt="Icon of Mail" draggable="false" className="img-fluid HeadContIcon" /></div>
                        <div className="d-flex flex-column justify-content-center align-items-start ps-3">
                            <div className="fw-bold HeadContIconHead">info@integroexim.com</div>
                            <div className="fw-medi cl-8b HeadContIconDes">Get An Estimate</div>
                        </div>

                    </a>
                </div>
            </li>
        </ul>
    </nav>
    <div className={`blackBG d-block d-lg-none ${activeNav && 'blackBGActive'}`} onClick={e => setActiveNav(false)}></div>

</header>
  )
}

export default Navbar